import { notification } from "antd"
import type { FormInstance } from "antd/es/form/hooks/useForm"
import { type ValidateErrorEntity } from "rc-field-form/es/interface"

import { notificationOptions } from "../../../constants/notification.config"

function isFormValidationError(error: unknown): error is ValidateErrorEntity {
  return Array.isArray((error as ValidateErrorEntity)?.errorFields)
}

function showDocumentValidationError(
  form: FormInstance,
  error: unknown
): boolean {
  if (!isFormValidationError(error)) return false

  const firstError = error.errorFields.find((field) => field.errors?.length)
  if (!firstError) return false

  form.scrollToField(firstError.name, {
    behavior: "smooth",
    block: "center",
    scrollMode: "always"
  })

  notification.warning({
    ...notificationOptions.warning,
    key: "document_validation_error",
    message: "The document cannot be saved",
    description: firstError.errors[0]
  })

  return true
}

export { isFormValidationError, showDocumentValidationError }
